<template lang="pug">
.container
  .grid.is-ultrawide-5.is-widescreen-6.is-desktop-7.is-tablet-8.is-center
    .column
      h4 Hello {{ user.firstName }}

      p Would you like to use this account to login to #[a(:href="origin.url") {{ origin.name }}]
      a.b-button.is-block.u-mt-mi(@click.prevent="$emit('consent')") #[AppIcon(name="email")] Yes Please
</template>

<script>
import Store from '@/store';

export default {
  computed: {
    user () {
      return Store.user;
    },
    origin () {
      return {
        url: 'https://board.baianat.net',
        name: 'Board'
      };
    }
  }
};
</script>
